
import { CoverageType, BuildingType, Technology, Operator } from './FbbEnum'
import { IModelUtil } from '../common/IModelUtil'
import * as log from '../../common/js/appLogger'

export class Coverage implements IModelUtil{
    
    protected isSuccess:boolean = false
    protected hkbnResultCode:string = ''
    protected operator:Operator
    protected coverageType:CoverageType //R / C
    protected buildingType:BuildingType //PUBLIC
    protected technologyList:Array<{technology: Technology, 
                                    haveCoverage: boolean, havePort: boolean,
                                    haveCoverage2000: boolean, haveCoverage2200: boolean,}> = [];   //GP

    protected bbPreinstalled:boolean = false     //NO API??????
    protected allowHolidayInstall:boolean = false //NO API??????

    protected allowDeferActivate:boolean = false

    protected haveHometelPort:boolean = false    //HKBN only

    constructor(_operator:Operator){
        this.operator = _operator

        this.isSuccess = false
        this.coverageType = CoverageType.Residential
        this.buildingType = BuildingType.Private
        this.technologyList = []

        this.bbPreinstalled = false
        this.allowHolidayInstall = false
        this.allowDeferActivate = false
        
        this.haveHometelPort = false
    }


    private parseHKBN(data:any){

        this.isSuccess = data.status === 'NORMAL'
        this.haveHometelPort = data.haveHometelPort ?? false
        this.hkbnResultCode = data.resultCode
    }

    private parseHGC(data:any){
        this.isSuccess = data.status === 'NORMAL'
        this.haveHometelPort = false
    }

    private parseICABLE(data:any){
        this.isSuccess = data.status === 'NORMAL'
        this.haveHometelPort = false
    }

    private parseCommon(data:any){
        
        //20250409: only HGC have 2000 and 2200.
        /*
        "hkbnResult":{
            "status":"NO_COVERAGE", //NORMAL, or Reject reason, see resultCode.
            "coverageType":"R/C",
            "buildingType":"PUBLIC/PRIVATE/VILLAGE",
            "technology":[
                { "type": "ME", "haveCoverage": true, "havePort": true },
                { "type": "GP", "haveCoverage": true, "havePort": true,  "haveCoverage2000": true, "haveCoverage2200": false },
                { "type": "DOS", "haveCoverage": true, "havePort": true }, //no such row if operator don't support
            ]
            "haveHometelPort": true,    //HKBN only
            "allowDeferActivate":false,
        },
        */
        this.coverageType = (data.coverageType ?? "_") === "C" ? 
                                   CoverageType.Commercial : CoverageType.Residential
        this.buildingType = BuildingType.Private                           
        switch(data.buildingType ?? "_"){
            case BuildingType.Private:
               this.buildingType = BuildingType.Private
               break;
            case BuildingType.Public:
               this.buildingType = BuildingType.Public
               break;
            case BuildingType.Village:
               this.buildingType = BuildingType.Village
               break;
        }
        this.allowDeferActivate = data.allowDeferActivate ?? false

        this.technologyList = []

        /* for 2000 and 2200, it will return inside GP
        { "type": "GP", "haveCoverage": false, "havePort": true, 
                                        "haveCoverage2000": true, "haveCoverage2200": true }
        2200 and others is GP, but 2000 is GP2.
        */
        data.technology?.forEach(aTech => { //api return
            if ( aTech.type in Technology ){
                var techObj = {technology: aTech.type, 
                                haveCoverage: aTech.haveCoverage ?? false, 
                                haveCoverage2200: aTech.type == Technology.GP ? aTech.haveCoverage2200 ?? false : false, 
                                haveCoverage2000: false, 
                                havePort: aTech.havePort ?? false}
                this.technologyList.push(techObj)
                // log.dt('GP2-ad', aTech.type)
                if ( aTech.type == Technology.GP ){
                    if ( aTech.haveCoverage2000 ){
                        var gp2TechObj = {technology: Technology.GP2, 
                            haveCoverage: true, 
                            haveCoverage2200: aTech.haveCoverage2200 ?? false, 
                            haveCoverage2000: true, 
                            havePort: aTech.havePort ?? false}
                        this.technologyList.push(gp2TechObj)
                    }
                }
            }
        });
        
        this.bbPreinstalled = false //NO API??????
        this.allowHolidayInstall = false //NO API??????

    }

    public readyTechnologies() : Technology[] {

        var list:Technology[] = []
        for(var aTech of this.technologyList ){
            if ( (aTech.haveCoverage || aTech.haveCoverage2200 ) 
                    && aTech.havePort ){ // || aTech.haveCoverage2000
                list.push(aTech.technology)
            }
        }
        return list
    }

    public haveCoverage() : boolean {
        for(var aTech of this.technologyList ){
            if ( aTech.haveCoverage || aTech.haveCoverage2200  ){ //|| aTech.haveCoverage2200 || aTech.haveCoverage2000
                return true
            }
        }
        return false
    }

    public getHkbnResultCode() : string {
        return this.hkbnResultCode
    }

    public getBuildingType() : BuildingType {
        return this.buildingType
    }

    public havePort() : boolean {
        for(var aTech of this.technologyList ){
            if ( aTech.havePort ){
                return true
            }
        }
        return false
    }

//=================================================================================
    //interface IModelUtil
    
    parseApiResult(data: any): void {

        this.parseCommon(data)

        if ( this.operator === Operator.hkbn ){
            this.parseHKBN(data)
        }
        else if ( this.operator === Operator.hgc ){
            this.parseHGC(data)
        }
        else if ( this.operator === Operator.icable ){
            this.parseICABLE(data)
        }

    }

    convertFromJson(json:any) : void {

        if ( json == null ){
            return
        }

        this.isSuccess = json.isSuccess ?? false
        this.hkbnResultCode = json.hkbnResultCode ?? ''
        this.operator = json.operator ?? Operator.hkbn
        this.coverageType = json.coverageType ?? CoverageType.Residential
        this.buildingType = json.buildingType ?? BuildingType.Private
        this.bbPreinstalled = json.bbPreinstalled === 'Y'
        this.allowHolidayInstall = json.allowHolidayInstall === 'Y'
        this.allowHolidayInstall = json.allowHolidayInstall === 'Y'
        this.allowDeferActivate = json.allowDeferActivate === 'Y'
        this.haveHometelPort = json.haveHometelPort === 'Y'

        this.technologyList = []
        for(var aTechJson of json.technologyList){
            var techObj = {technology: aTechJson.technology, 
                haveCoverage: aTechJson.haveCoverage === 'Y', havePort: aTechJson.havePort === 'Y',
                haveCoverage2200: aTechJson.haveCoverage2200 === 'Y',
                haveCoverage2000: aTechJson.haveCoverage2000 === 'Y',     }
            this.technologyList.push(techObj)
        }

    }

    convertToJson() : any {
        
        var techListJson = []
        for(var aTech of this.technologyList ){
            var aTechJson = {
                technology: aTech.technology,
                haveCoverage: aTech.haveCoverage ? 'Y' : 'N',
                haveCoverage2200: aTech.haveCoverage2200 ? 'Y' : 'N',
                haveCoverage2000: aTech.haveCoverage2000 ? 'Y' : 'N',
                havePort: aTech.havePort ? 'Y' : 'N',
            }
            techListJson.push(aTechJson)
        }

        var json = {
            isSuccess: this.isSuccess ? 'Y' : 'N',
            hkbnResultCode:this.hkbnResultCode,
            operator: this.operator,
            coverageType: this.coverageType,
            buildingType: this.buildingType,
            bbPreinstalled: this.bbPreinstalled ? 'Y' : 'N',
            allowHolidayInstall: this.allowHolidayInstall ? 'Y' : 'N',
            allowDeferActivate: this.allowDeferActivate ? 'Y' : 'N',
            haveHometelPort: this.haveHometelPort ? 'Y' : 'N',
            technologyList: techListJson
        }
 
        return json

    }

    getHaveHometelPort(){
        return this.haveHometelPort
    }
}